import { webAPI } from '../../../axiosInstance';


const getOrders = async (orderDetails: any) => {
  console.log('orderDetails', orderDetails);

  // Prepare the params object
  const params: any = {
    start_page: orderDetails.pages.startPage,
    limit: orderDetails.pages.itemsperpage,
  };

  // Include the orderCode parameter only if it's not empty
  if (orderDetails.orderCode) {
    params.orderCode = orderDetails.orderCode;
  }

  const response = await webAPI.get('/orders', { params });
  return response.data;
};

export { getOrders };
